import React, {useState} from 'react';
import styled from 'styled-components';
import TaskBadgeAndName from './TaskBadgeAndName';
import {useIsDrawerMode} from '../../../util/Ares/customHooks';

export default function TaskRow(props) {
	const {task, engagement, hoveredTaskControls, taskInNewTab, taskName, className, showLink = true} = props;

	const _taskInNewTab = taskInNewTab || useIsDrawerMode();

	const [isHovered, setIsHovered] = useState(false);

	const _taskName = taskName || task.taskDisplayName || task.taskName;

	const onMouseHandle = (val) => {
		hoveredTaskControls && setIsHovered(val);
	};

	return (
		<StyledTaskRow
			className={`StyledTaskRow${className ? ' ' + className : ''}`}
			onMouseEnter={() => onMouseHandle(true)}
			onMouseLeave={() => onMouseHandle(false)}
		>
			<TaskBadgeAndName
				noBackground
				noBorderPadding
				showLink={showLink}
				linkNewWindow={_taskInNewTab}
				taskId={task.id}
				taskTypeId={task.typeId || task.taskTypeId}
				taskName={_taskName}
				taskVersionNumber={task.taskUIVersion}
				linesBeforeEllipse={1}
				badgeOnNewLine={false}
				isEp={task.isEPSignoffRequired || task.isEPSignoffUserRequired}
				isEq={task.isEQRSignoffRequired || task.isEQRSignoffUserRequired}
				engagement={engagement}
				includePipe={false}
			/>
			{isHovered && (
				<section className="hoveredTaskControls">
					{hoveredTaskControls && hoveredTaskControls(task, engagement)}
				</section>
			)}
		</StyledTaskRow>
	);
}

const StyledTaskRow = styled.section`
	display: flex;
	width: 100%;
	.StyledTaskNames {
		width: 100%;
		.TaskBadges,
		.TaskNames {
			font-size: var(--px-12);
			font-weight: 400;
			line-height: var(--px-20);
			a {
				font-size: var(--px-12);
				font-weight: 400;
				line-height: var(--px-20);
				color: var(--neutrals-900) !important;
				&:hover,
				&:focus {
					text-decoration: none !important;
					color: var(--neutrals-900) !important;
				}
			}
		}
	}
`;
